<template>
  <div class="content-warpper">
    <div class="warpper-title">
      <i class="iconfont iconzhanghao"></i>
      角色管理
    </div>
    <div class="padding-sm">
      <div class="flex align-center justify-between margin-bottom-sm">
        <div class="flex align-center condition-warpper">
          <el-input v-model="keyword" placeholder="角色名称" class="margin-right-sm"></el-input>

          <el-button type="primary" @click="onSearch">
            <p class="flex align-center font-size"><i class="el-icon-search margin-right-xs"></i>搜索</p>
          </el-button>
        </div>
        <el-button type="primary" @click="roleDialog = true">
          <p class="flex align-center font-size"><i class="iconfont iconxinzeng margin-right-xs"></i>新增角色</p>
        </el-button>
      </div>
      <div class="table-warpper">
        <el-table
            :data="roleList"
            header-row-class-name="table-header"
            row-class-name="table-row"
            alig="center"
            fit
            style="width: 100%">
          <el-table-column
              width="70"
              align="center"
              type="index"
              label="序号">
          </el-table-column>
          <el-table-column
              label="角色名称">
            <template slot-scope="scope">
              <div class="table-item">
                {{ scope.row.role_name }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
              label="所属模块">
            <template slot-scope="scope">
              <div class="table-item">
                {{ scope.row.region_id_text  }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
              label="所属项目">
            <template slot-scope="scope">
              <div class="table-item">
                {{ scope.row.item_name }}

              </div>
            </template>
          </el-table-column>
          <el-table-column
              align="center"
              label="状态">
            <template slot-scope="scope">
              <div class="table-item">
                {{ scope.row.status === 0 ? '停用' : '正常' }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
              label="操作时间">
            <template slot-scope="scope">
              <div class="table-item">
                {{ scope.row.add_time }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
              fixed="right"
              label="操作"
              width="260">
            <template slot-scope="scope">
              <div class="table-operate">
                <el-button size="medium" type="primary" @click="editItem(scope.row)">编辑</el-button>
                <el-button size="medium" type="danger" @click="deleteItem(scope.row.role_id)">删除</el-button>
                <el-button size="medium" type="warning" @click="closeItem(scope.row.role_id)" v-if="scope.row.status === 1">停用</el-button>
                <el-button size="medium" type="primary" @click="openItem(scope.row.role_id)" v-if="scope.row.status === 0">启用</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
            v-if="roleList.length>0"
            class="page-all"
            background
            @current-change="setPage"
            :current-page.sync="page"
            :page-size="limit"
            layout="prev, pager, next, jumper"
            :total="total">
        </el-pagination>
      </div>
    </div>
    <roleDialog
        :setId="setId"
        :setItem="setItem"
        :roleDialog="roleDialog"
        @cancelDialog="cancelDialog"
    />
  </div>
</template>

<script>
import roleDialog from "@/views/admin/page/dialog/roleDialog";
import {roleList, roleDel, roleSet,} from "@/api/admin";
export default {
  name: "role",
  components: {
    roleDialog
  },
  data() {
    return {
      keyword: "",
      roleList: [],
      page: 1,
      total: 0,
      limit: 10,
      setId: 0,
      setItem: {},
      roleDialog: false
    }
  },
  created() {
    this.$emit("setIndex", this.$route.path, "当前位置：系统管理 > <span>角色管理</span>", false);
    this.getList()
  },
  methods: {
    async getList() {
      let _list = await roleList(this.keyword, this.page, this.limit)
      this.roleList = _list.data.list
      this.total = _list.data.count
    },
    setPage() {
      this.getList();
    },
    onSearch() {
      this.page = 1;
      this.getList();
    },
    editItem(obj) {
      this.setItem = obj;
      this.setId = obj.role_id;
      this.roleDialog = true;
    },
    deleteItem(id) {
      this.$confirm("确定要删除该角色吗？", "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        cancelButtonClass: "msg-btn",
        confirmButtonClass: "msg-btn",
        center: true
      }).then(() => {
        this.sureDelete(id)
      });
    },
    async sureDelete(id) {
      let _state = await roleDel(id)
      if (this.roleList.length === 1 && this.page > 1) {
        this.page--
      }
      this.getList();
      this.$message.success(_state.msg)
    },
    closeItem(id) {
      this.$confirm("确定要停用该角色吗？", "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        cancelButtonClass: "msg-btn",
        confirmButtonClass: "msg-btn",
        center: true
      }).then(() => {
        this.sureClose(id)
      });
    },
    async sureClose(id) {
      let _state = await roleSet(id, 0)
      this.getList();
      this.$message.success(_state.msg)
    },
    openItem(id) {
      this.$confirm("确定要启用该角色吗?", "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        cancelButtonClass: "msg-btn",
        confirmButtonClass: "msg-btn",
        center: true
      }).then(() => {
        this.sureOpen(id)
      });
    },
    async sureOpen(id) {
      let _state = await roleSet(id, 1)
      this.getList();
      this.$message.success(_state.msg)

    },
    cancelDialog(val) {
      if (val) {
        this.setId = 0;
        this.setItem = {};
        this.roleDialog = false;
        if (this.setId) {
          this.getList();
        } else {
          this.page = 1;
          this.getList();
        }
      } else {
        this.setId = 0;
        this.setItem = {};
        this.roleDialog = false;
      }
    }
  },
  filters:{
    xietiao(val){
      switch (val){
        case 2:
          return '培训协调中心'
        case 3:
          return '实习协调中心'
        case 4:
          return '考场协调中心'
        case 5:
          return '教学协调中心'
      }
    }
  }
}
</script>

<style scoped lang="scss">

</style>